import { notify } from 'react-notify-toast';

const showToast = (message, delay = 2500) => {
  let myColor = { background: '#0E1717', text: "#FFFFFF" };
  notify.show(message, 'warning', delay, myColor);
};

export { showToast };